<template>
    <div class="promo-fine-finish" v-if="indexPage != null && indexPage.promo_fine_finish != null && indexPage.promo_fine_finish.init == 'true'">
        <div class="container">
            <div class="column-container">
                <div class="col-right">
                    <div class="content-carousel">
                        <div class="logo">
                            <img :src="indexPage.promo_fine_finish.logo" alt="">
                        </div>
                    </div>
                    <div class="col-carousel">
                        <swiper :options="swiperOption" ref="promoFineCarousel" id="promoFineCarousel">
                            <swiper-slide v-for="(slide, index) in indexPage.promo_fine_finish.gallery" :key="index">
                                <div class="pic" :style="'background-image: url(' +  slide.url + ')'"></div>
                                <!-- <div class="promo-set"></div> -->
                            </swiper-slide>
                        </swiper>
                    </div>
                </div>
                <div class="col-left">
                    <div class="section-title-new section-title-fine-finish">
                        <h3 v-if="globalLang == ''">Чистовая отделка</h3>
                        <h3 v-if="globalLang == 'kz/'">Бастапқы әрлеу</h3>
                        <h3 v-if="globalLang == 'en/'">Fine-Finish</h3>
                    </div>
                    <div class="col-desc" v-html="indexPage.promo_fine_finish.desc"></div>
                    <a :href="indexPage.promo_fine_finish.btn_calc.link" target="_blank" class="link-to-calc">{{indexPage.promo_fine_finish.btn_calc.name}}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'sales-fine-finish-promo',
        components: {
        },
        data () {
            return {
                globalLang: window.GlobalLang, 
                swiperOption: {
                    speed: 800,
                    observer: true,
                    observeParents: true,
                    effect: 'fade',
                    loop: true,
                    spaceBetween: 0,
                    autoplay: {
                        delay: 2000,
                        disableOnInteraction: true,
                    },
                    navigation: {
                        nextEl: '.gal-next-slide',
                        prevEl: '.gal-prev-slide',
                    }
                },
            }
        },
        computed: mapGetters({
            indexPage: 'loadIndexPage',
        }),
        methods: {
            startLoader() {
                this.$parent.$parent.$refs.topProgress.start();
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/index-promo/promo-fine-finish.scss';
    @import '@/styles/respond/index-promo/respond-promo-fine-finish.scss';
</style>